import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';
import { StorageManagerService } from './storage-manager.service';
import { DeviceModel } from '../models/device-management';
import { Observable } from 'rxjs';
import { generateGUID } from './helpers/helper-functions';

declare var webOS: any;
declare var tizen: any;

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementService {

    public readonly deviceIdentifier: string;
    public readonly device: DeviceModel;

    constructor(private env: EnvironmentService,
                private http: HttpClient,
                private storage: StorageManagerService) {
        this.deviceIdentifier = this.storage.deviceIdentifier;
        if (!this.deviceIdentifier) {
            this.deviceIdentifier = generateGUID();
            this.storage.deviceIdentifier = this.deviceIdentifier;
        }

        let model: string = 'Smart TV';
        try {
            if (webOS) {
                model = 'LG TV';
            }
        } catch {}
        try {
            if (tizen !== null && tizen !== undefined) {
                model = 'Samsung TV';
            }
        } catch {}
        try {
            if ((window as any).chrome && (window as any).chrome.webview) {
                model = 'Xbox'
            }
        } catch {}

        this.device = {
            deviceIdentifier: this.deviceIdentifier,
            isActive: true,
            platform: 'stv',
            model: model
        }
    }

    addDevice(): Observable<any> {
        return this.http.post<any>(`${this.env.userHost}/v2/device`, this.device);
    }
}
